import { render } from "./UnregisterComplete.vue?vue&type=template&id=7c44ad8e"
import script from "./UnregisterComplete.vue?vue&type=script&lang=js"
export * from "./UnregisterComplete.vue?vue&type=script&lang=js"

import "./UnregisterComplete.vue?vue&type=style&index=0&id=7c44ad8e&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__